import { render, staticRenderFns } from "./BaseLivingDonor.vue?vue&type=template&id=973ec20c"
import script from "./BaseLivingDonor.vue?vue&type=script&lang=ts"
export * from "./BaseLivingDonor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports